module.exports = __webpack_public_path__ + "img/map.4d3fd64f.jpg";